import {
  BuyInBulkCollegeImage,
  CollegePartnershipPlanImage,
  PublishBooksCollegeImage,
} from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForCollegesSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'Publish Your Books',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PublishBooksCollegeImage,
      pointers: [
        'Publish institution-specific academic and learning content',
        'Reach students through structured digital distribution',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'Buy in Bulk',
      button: {
        link: 'https://go.zebralearn.com/inquiry-form',
        text: 'Contact Us →',
      },
      image: BuyInBulkCollegeImage,
      pointers: [
        'Affordable pricing for institutions',
        'Ideal for classrooms & libraries',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 3,
      title: 'College Partnership Plan',
      button: {
        link: 'https://go.zebralearn.com/inquiry-form',
        text: 'Contact Us →',
      },
      image: CollegePartnershipPlanImage,
      pointers: [
        'Long-term collaboration for curriculum and learning resources',
        'Custom publishing, bulk access, and institutional support',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Colleges' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForCollegesSection;
